module.exports = __webpack_public_path__ + "img/Hero Section.f1d2064c.png";